// TIPOS USADOS NO MODEL-MAP
export const enum EModelMapType {
  ELEMENT_CONSTRUCTIVE = "EC",
  MATERIAL = "MAT",
}



// WEBPACK FOOTER //
// ./src/common/enums/ModelMap.ts